import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FormulaCobro } from '../../model/formula-cobro';
import { FormulaCobroService } from '../../services/formula-cobro.service';

@Component({
  selector: 'app-tipo-formula-cobro',
  templateUrl: './tipo-formula-cobro.component.html',
  styleUrls: ['./tipo-formula-cobro.component.css']
})

export class TipoFormulaCobroComponent implements OnInit {

  @Output() tipoSeleccionado: String;
  @Input() fields: FormulaCobro[];
  @Input() fieldSelect: string;
  @Input() tipoFormula: string;
  @Output() selectEvent = new EventEmitter();

  public query: any;
  public seleccionActual: String;

  constructor(
    private _formulaService: FormulaCobroService
  ) { }

  ngOnInit() {
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.getFormulas();
  }


  getFormulas() {
    this.query = { "TIPO": this.tipoFormula };
    this._formulaService.getFormulasCobros(this.query).subscribe(
      data => {
        this.fields = data;
      },
      err => {
        console.log(err);
      });
  }

  onSelected(valor: any) {
    this.tipoSeleccionado = valor;
    this.selectEvent.emit(this.tipoSeleccionado);
  }

}


// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/tipo-formula-cobro/tipo-formula-cobro.component.ts